import { Controller } from "@hotwired/stimulus"

// Demo-only: for the gated Programs mock. The "pop" enrollment rows fade in one
// after another once scrolled into view, and each one increments the stat card
// whose data-status matches the row's status (a completed enrollment bumps the
// Completed count, etc.).
export default class extends Controller {
  static targets = ["pop", "stat"]

  connect() {
    if (!this.hasPopTarget) return
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.observer.disconnect()
          this.run()
        }
      },
      { threshold: 0.3 },
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    this.timers?.forEach(clearTimeout)
  }

  run() {
    this.timers = this.popTargets.map((el, i) =>
      setTimeout(() => this.reveal(el), 400 + i * 650),
    )
  }

  reveal(el) {
    // Un-hide (so the row takes space), force a reflow so the browser registers
    // the now-visible row, then drop opacity-0 so it fades in together.
    el.classList.remove("hidden")
    void el.offsetWidth
    el.classList.remove("opacity-0")
    const stat = this.statTargets.find((s) => s.dataset.status === el.dataset.status)
    if (stat) this.bump(stat)
  }

  bump(stat) {
    stat.textContent = String(Number(stat.textContent.trim()) + 1)
    stat.classList.add("scale-125")
    setTimeout(() => stat.classList.remove("scale-125"), 220)
  }
}
